import { createContext, useState } from "react";
import type { ReactNode, Dispatch, SetStateAction } from "react";

export type DownloadProgressTuple = [number, number];
export type DownloadProgressMap = Record<string, DownloadProgressTuple>;

interface DownloadProgressContextValue {
  remaining: DownloadProgressMap;
  setRemaining: Dispatch<SetStateAction<DownloadProgressMap>>;
}

export const DownloadProgressContext = createContext<DownloadProgressContextValue>({
  remaining: {},
  setRemaining: () => {},
});

interface DownloadProgressProviderProps {
  children: ReactNode;
}

export const DownloadProgressProvider = ({
  children,
}: DownloadProgressProviderProps) => {
  const [remaining, setRemaining] = useState<DownloadProgressMap>({});

  return (
    <DownloadProgressContext.Provider value={{ remaining, setRemaining }}>
      {children}
    </DownloadProgressContext.Provider>
  );
};
